/* src/app/projects/project-edit/description/project-edit-description.component.scss */
/*# sourceMappingURL=project-edit-description.component-VJ2Z3GVP.css.map */
